import React, {useEffect, useState} from 'react';

import {TouchableWithoutFeedback, Keyboard, Platform, View} from 'react-native';


import {Header} from '../../../../components/Interface/Headers/Header';

import {
  Container,
  Content,
  ContentHeader,
  Regions,
  RegionContainer,
  RegionTitle,
  ArrowIcon,
  RegionTitleContainer,
} from './styles';
import {SearchInput} from '../../../../components/Interface/Forms/Inputs/SearchInput';
import {Titles} from '../../../../components/Interface/Typographies/Titles';
import {NotFound} from '../../../../components/Interface/Search/NotFound';
import {RFValue} from 'react-native-responsive-fontsize';

import {trackEvent} from '../../../../lib/analytics';
import {useHelpers} from '../../../../context/helpers';
import {CidadesDTO} from '../../../../dtos/RegiaoDTO';
import {Badge} from '../../../../components/Interface/Badges/Badge';
import {useTheme} from 'styled-components/native';
import {addInAppTrigger} from '../../../../lib/pushMessaging';

interface Props {
  action: (cidade: string) => void;
  cidades: CidadesDTO[];
  stateId: string;
  tipo: string;
}

export function SubRegionsList({action, cidades}: Props) {
  const theme = useTheme();
  const {ordenaCidadesOrdemAlfabetica} = useHelpers();

  const [data, setData] = useState<CidadesDTO[]>(cidades as CidadesDTO[]);
  const [allCities, setAllCities] = useState<CidadesDTO[]>(cidades as CidadesDTO[]);
  const [search, setSearch] = useState('');

  useEffect(() => {
     if (Platform.OS !== "web") {
        addInAppTrigger('screen', 'fuel_cities');
     }
  }, [])

  useEffect(() => {
    setData(cidades as CidadesDTO[]);
    setAllCities(cidades as CidadesDTO[]);
  }, [cidades]);
  
  function normalizeText(value: string) {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  async function searchRegions(name: string) {
    trackEvent('search', {
      search_term: name,
    });

    setSearch(name);

    try {
      const termo = normalizeText(name.trim());
      if (!termo) {
        setData(allCities);
        return;
      }

      const filtrado = allCities.filter((cidade) => {
        const nomeCidade = normalizeText(String(cidade?.cidade ?? ''));
        return nomeCidade.includes(termo);
      });

      setData(filtrado);
    } catch (err) {
      console.log(err);
    }
  }

  async function handleRegion(cidade: string) {
    action(cidade);
  }

  interface IBreve {
    breve: boolean;
    cidade: string;
  }

  let em_breve_items: IBreve[] = [] as IBreve[];

  data.map(cidade => {
    cidade.regioes.map(regiao => {
      em_breve_items.push({
        breve: regiao.breve,
        cidade: cidade.cidade,
      });
    });
  });

  return (
    <TouchableWithoutFeedback onPress={() => Platform.OS !== "web" && Keyboard.dismiss()} accessible={false}>
      <Container>
        <Header icon="chevron-left" />

        <Content>
          <ContentHeader>
            <Titles title="Qual cidade?" />
            <SearchInput
              placeholder="Buscar cidade"
              onChangeText={text => searchRegions(text)}
              value={search}
            />
          </ContentHeader>

          <Regions
            contentContainerStyle={{paddingBottom: RFValue(20)}}
            showsVerticalScrollIndicator={false}>
            {search.length !== 0 && data.length < 1 ? (
              <NotFound />
            ) : (
              ordenaCidadesOrdemAlfabetica(data).map((item: CidadesDTO) => {
                const isBreve = !!em_breve_items
                  .filter(b => b.cidade === item.cidade)
                  .find(b => b.breve === true);

                return isBreve ? (
                  <RegionContainer key={item.cidade} activeOpacity={1}>
                    <>
                      <RegionTitleContainer>
                        <RegionTitle>{item.cidade}</RegionTitle>
                        <View>
                          <Badge
                            text="Em Breve"
                            textStyle={{color: theme.colors.shape}}
                            containerStyle={{
                              backgroundColor: theme.colors.blue,
                              borderColor: theme.colors.blue,
                              marginLeft: RFValue(6),
                            }}
                          />
                        </View>
                      </RegionTitleContainer>
                    </>
                  </RegionContainer>
                ) : (
                  <RegionContainer
                    key={item.cidade}
                    onPress={() => handleRegion(item.cidade)}
                    underlayColor={theme.colors.button_click_bg}
                    disabled={isBreve}>
                    <>
                      <RegionTitleContainer>
                        <RegionTitle>{item.cidade}</RegionTitle>
                      </RegionTitleContainer>

                      <ArrowIcon name="chevron-right" />
                    </>
                  </RegionContainer>
                );
              })
            )}
          </Regions>
        </Content>
      </Container>
    </TouchableWithoutFeedback>
  );
}
